export let primaryColor = '#AEA1BD';
export let primaryColorLight = "#D1CADA";
export let primaryColorDark = '#4B4157';
export let secondaryColor = '#E9E9E9';

export let buttonHoverColor = "#8c7aa266";
export let buttonColor = "#b6a9c7";
export let fontfamily = 'Nunito Sans';
